<template>
  <section :class="['profile__block avatar_selection pattern']">
    <div class="profile__block__header">
      <h2>{{ getTranslations.home_profile_profile_edit_set_profile_picture }}</h2>
    </div>
    <facebook-login :enteredUsername="userDetails.username"
                    :errorsInFb="errorInConnectFb"
                    v-if="hasFbButton()"
                    @errorsUpdated="methodForEvent($event)"
                    :type="fbActionType">
    </facebook-login>
    <span class="custom_fb_error_msg"
          v-if="errorInConnectFb">{{ getTranslations.home_store_this_fb }}
    </span>
    <section>
      <div class="profile__block__content profile__block__content--edit-avatar">
        <div class="tab-header">
          <a href="#" :class="{ active: isActive('male') }" data-target="male" @click.prevent="setActive('male')">
            {{ getTranslations.home_profile_profile_edit_gender_male }}
          </a>
          <a href="#" :class="{ active: isActive('female') }" data-target="female" @click.prevent="setActive('female')">
            {{ getTranslations.home_profile_profile_edit_gender_female }}
          </a>
        </div>
        <div class="tab-container">
          <avatar-tab id="male" :is-active="isActive('male')" :gender="'male'"/>
          <avatar-tab id="female" :is-active="isActive('female')" :gender="'female'"/>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import Flickity from 'vue-flickity';
import FacebookLogin from '@/components/visitor/FacebookLogin';
import AvatarTab from '@/components/home/profile/AvatarTab';

export default {
  name: 'avatar-selection',
  components: {
    Flickity,
    FacebookLogin,
    AvatarTab,
  },
  data() {
    return {
      activeTab: 'male',
      defaultProfilePic: 'static/images/avatar_default.png',
      errorInConnectFb: false,
      fbActionType: 'connect',
      numberOfAvatarImages: 17,
      flickityOptions: {
        initialIndex: 0,
        wrapAround: true,
        adaptiveHeight: true,
        groupCells: true,
      },
    };
  },
  created() {
    this.setProfilePath(true);
  },
  methods: {
    ...mapMutations('common', [
      'setProfilePath',
    ]),
    setActive(gender) {
      this.activeTab = gender;
    },
    isActive(gender) {
      return this.activeTab === gender;
    },
    methodForEvent(event) {
      this.errorInConnectFb = event;
    },
    hasFbButton() {
      return this.$route.path === '/home/profile/edit'
        && !this.userDetails.facebookId
        && this.facebookFunctionality;
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'profilePath',
      'facebookFunctionality',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/AvatarSelection.vue